/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './RMDTableNew.scss';
import React, { useState } from 'react';
import {accountNumber, currency, lastBusinessDateNumeric} from '../../../utils/dashboard-utils';
import {useDispatch, useSelector} from 'react-redux';
import { getRMDSummary} from '../../../redux/modules/RMD/RMDSetting.selectors';
import {getBalanceAsOfDate, getRMDPlusAsOf} from '../../../redux/modules/UserFunds/userFunds.selectors';
import styles from "../RMDAccounts/RMDAccountsNew.module.scss";
import {AS_OF_ACCOUNT_BALANCES, openModal as openModalAction} from "../../../redux/modules/modals/modals.module";
import toolTip from "../../../assets/images/Tooltip.svg";

const TableBody = (props) => {
  const rmdSummary = useSelector(getRMDSummary);
  const balanceAsOfDate = useSelector(getBalanceAsOfDate);
  const dispatch = useDispatch();
  const { preRMDEligible } = rmdSummary;
  const rmdAgreements = props?.retirementPlans?.rmdAgreements;
  const remainingLength = rmdAgreements.length - 5;
  const [showMore, setShowMore] = useState(false);
  if (props) {
    if (!preRMDEligible) {
      return (
        <tbody>
          { props.showYTDColumns &&
            rmdAgreements?.map(
              (fund, index) =>
                (index <= 4 || showMore) && (
                  <tr className="fund" key={index + 1}>
                    <td className="name">{fund.accountNameDisplay}</td>
                    <td className="account blocked_data">
                      {accountNumber(fund)}
                    </td>
                    <td className="account-balance">
                      {currency(fund.balance)}
                    </td>
                    <td className="year-rmd">{currency(fund.rmdamount)}</td>
                    <td className="distributions-ytd">
                      {currency(fund.distributionYTD)}
                    </td>
                    {fund.planName === 'IRA' || fund.planName === '403(b)' ? (
                      <td className="remaining-year">
                        <div className="greyedout"></div>
                      </td>
                    ) : (
                      <td className="remaining-year">
                        {currency(fund.remainingRMDForYear)}
                      </td>
                    )}
                    <td className="tax-ytd">
                      {currency(fund.taxWithHoldingsYTD)}
                    </td>
                  </tr>
                )
            )}
          {!props.showYTDColumns &&
            rmdAgreements?.map(
              (fund, index) =>
                (index <= 4 || showMore) && (
                  <tr className="fund" key={index + 1}>
                    <td className="name">{fund.accountNameDisplay}</td>
                    <td className="account blocked_data">
                      {accountNumber(fund)}
                    </td>
                    <td className="account-balance">{currency(fund.balance)}</td>
                    <td className="year-rmd">{currency(fund.rmdamount)}</td>
                  </tr>
                )
            )}
          {!showMore && remainingLength > 0 && (
            <tr>
              <td>
                <button
                  className="showMore"
                  onClick={() => setShowMore(!showMore)}
                >
                  View complete RMD Summary breakdown. {remainingLength} more
                  rows available.
                </button>
              </td>
            </tr>
          )}
        </tbody>
      );
    }
    return (
      <tbody>
        {rmdAgreements?.map(
            (fund, index) =>
              (index <= 4 || showMore) && (
                <tr className="fund" key={index + 1}>
                  <td className="name">
                    {fund.accountNameDisplay}
                    {balanceAsOfDate !== fund.currentBalance?.balanceAsOfDate && fund.productType !== "MUTUAL_FUND" && (
                      <div className={`${styles['sub-title']}`}>
                        As of {lastBusinessDateNumeric(fund.balanceAsOfDate)}
                        <button
                           onClick={(e) => dispatch(openModalAction(AS_OF_ACCOUNT_BALANCES,
                             {type: fund.productType}))}
                           className={`${styles['button-modal']}`}
                        >
                          <img
                            className={styles['disable-img']}
                            src={toolTip}
                            alt="tool tip icon"
                          />
                       </button>
                      </div>
                    )}
                  </td>
                  <td className="account blocked_data">
                    {accountNumber(fund)}
                  </td>
                  <td className="account-balance">{currency(fund?.currentBalance?.balance)}</td>
                </tr>
              )
          )}
        {!showMore && remainingLength > 0 && (
          <tr>
            <td>
              <button
                className="showMore"
                onClick={() => setShowMore(!showMore)}
              >
                View complete RMD Summary breakdown. {remainingLength} more rows
                available.
              </button>
            </td>
          </tr>
        )}
      </tbody>
    );
  }
  return null;
};
export default TableBody;
